import React, { Component, Fragment } from "react";
import Ajax from "Pub/js/ajax";
import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";
import { langCheck, getMyAppInfoValue, queryRecentVisit } from "Pub/js/utils";
import { MYAPP, NOTMYAPP, MYAPPINFO, MYCOLLECT, RECENTVISIT, getCloudMenus, getMenus } from "Pub/js/allApps";
import { TransitionIn } from "Components/Transition";
import Loading from 'Components/Loading';
import MyContent from "./content";
import { ControlTip } from "Components/ControlTip";
import _ from 'lodash';
import "./index.less";
import { scroller, Element } from 'react-scroll';
import CardItem from './CardItem';
import { setStore, getStore } from "Pub/js/storageUtils";
import * as NavAppIcons from 'Pub/js/navNodeIcons';
import myAppImg from "Assets/images/menuicons/my_collect.svg";
import MyCollect from "Assets/images/menuicons/my_collect1.svg";
import RecentVisitImg from "Assets/images/menuicons/zuijinfangwen.svg";

const API_URL = {
    queryAppCollects: '/nccloud/platform/appregister/queryappcollect.do', //查询收藏接口
};
const HR_FIELD_CODE = "60"; //人力领域编码
class AllApps extends Component {
    constructor(props) {
        super(props);
        this.state = {
            appGroupArr: [],
            collapsedFields: [],
            contentData: [],
            isSelectModuleID: 0,
            json: {},
            navAppInfo: this.props.navAppInfo,
            isActive: false,
            myAppData: {
                image_src: myAppImg,
                label: langCheck("0000PUB-000552"), //多语 - 我的应用
                value: MYAPP,
            },
            showContent: false, // 收藏右侧动画
            cloudMenuData: [], //bip云菜单
            // allappShowContent: false // 应用菜单 右侧动画
        };
    }
    componentDidMount() {
        // 单点登录时 设置下collectNavAppInfo值
        if (getStore(MYAPPINFO) == null) {
            setStore(MYAPPINFO, { value: NOTMYAPP, key: 0 });
        }
        const collectValue = getMyAppInfoValue();
        if (collectValue !== NOTMYAPP || this.props.isHome) {
            // 默认 或 点击收藏时都需求请求收藏接口 只有主动点击应用下节点才不请求  
            this.getMyappData();//取我的收藏数据
            // const newAppInfo = getStore(MYAPPINFO);
            // this.props.onUserSelectModule(newAppInfo);
            // this.setState({ navAppInfo: newAppInfo, isActive: false });
            // 打开菜单后 默认定位我的应用
            this.onExpandedCollect();
        }
        const p1 = this.getApps();
        // 查bip云菜单
        const p2 = getCloudMenus({
            info: {
                name: langCheck('0000PUB-000101'), /* 国际化处理： 所有应用*/
                appcode: '10228888',
                action: langCheck('0000PUB-000102'), /* 国际化处理： 查询一二级领域模块*/
            }
        });
        // ncc菜单和bip菜单都请求完把数据合并到一起
        Promise.all([p1, p2]).then(([p1Data, p2Data]) => {
            const data = [...p1Data, ...p2Data];
            let collapsedFields = getStore('COLLAPSEDFIELDS');
            if (!collapsedFields) {
                collapsedFields = _.map(data, el => ({
                    value: el.value,
                    expanded: true,
                }));
            }
            setStore('COLLAPSEDFIELDS', collapsedFields);
            // 合并人力菜单 新需求 不再合并菜单
            // const newData = this.mergeHRModules(data);
            this.setState({
                appGroupArr: data,
                collapsedFields,
            });
            let firstLevelModule = this.findFirstLevelModule();
            if (collectValue && collectValue === NOTMYAPP && !this.props.isHome) {
                if (firstLevelModule) {
                    this.setModuleSelect(this.findAppItemModuleId());
                    _.each(collapsedFields, el => {
                        if (el.value === firstLevelModule.value) {
                            el.expanded = true;
                        }
                    });
                } else {
                    this.setModuleSelect(data[0].children[0]);
                    collapsedFields[0].expanded = true;
                }
            }
            this.setState({ collapsedFields: [...collapsedFields] });
            this.scrollAllGroup();
        });
    }
    componentWillReceiveProps(nextProps) {
        if (this.checkAllAppShow(nextProps.showAllApp)) {
            const moduleId = getMyAppInfoValue();
            // 点击面包屑打开强制定位
            if (nextProps.breadCrumbClick || (moduleId && moduleId == NOTMYAPP)) {
                this.setState({ navAppInfo: nextProps.navAppInfo }, () => {
                    this.setModuleSelect(this.findAppItemModuleId());
                    this.scrollAllGroup();
                });
            } else {
                this.getMyappData(); // 取我的收藏数据
            }
        }
        // if (_.isEqual(nextProps.navAppInfo, this.props.navAppInfo)) {
        //     this.setState({
        //         navAppInfo: nextProps.navAppInfo
        //     })
        // }
    }
    checkAllAppShow(showAllApp) {
        return showAllApp === true && this.props.showAllApp !== showAllApp;
    }
    checkNavAppInfoChanged(navAppInfo) {
        let ret = true;
        let { navAppInfo: curNavAppInfo } = this.state;
        if (curNavAppInfo && navAppInfo && curNavAppInfo.b1 === navAppInfo.b1 && curNavAppInfo.b2 === navAppInfo.b2) {
            ret = false;
        }
        // 为 我的收藏 每次打开都发请求
        if (navAppInfo && navAppInfo.value === MYAPP) {
            ret = true;
        }
        return ret;
    }
    scrollAllGroup() {
        let firstLevelModule = (this.findFirstLevelModule() && this.findFirstLevelModule().value) || getMyAppInfoValue();
        if (firstLevelModule) {
            scroller.scrollTo(`nav_${firstLevelModule}`, {
                spy: true,
                smooth: false,
                duration: 250,
                containerId: 'domain-group-container',
            });
        }
    }

    handleUpdate = () => {
        this.forceUpdate();
    }
    getModuleInfo = (moduleID, appGroupArr) => {
        let { navAppInfo: curNavAppInfo } = this.props;
        curNavAppInfo = curNavAppInfo || {};
        if (moduleID === MYAPP) {
            const myApp = langCheck('0000PUB-000552'); //多语 - 我的应用
            const myCollect = langCheck('0000PUB-000404'); //多语 - 我的收藏
            return { b1: myApp, b2: '', b3: myCollect, n: curNavAppInfo.n };
        }

        let labelArr = [];
        const getModuleId = (dataSource, result = []) => {
            dataSource.forEach(el => {
                let { children, label, value } = el;
                if (children && children.length > 0) {
                    let item = children.find(item => item.value === moduleID);
                    if (item) {
                        labelArr = result.concat([label, value, item.label, item.value]);
                    } else {
                        return getModuleId(children, result.concat(label, value));
                    }
                }
            });
            return result;
        };
        if (appGroupArr) {
            getModuleId(appGroupArr);
            const [b1, value1, b2, value2, third, thirdValue] = labelArr;
            let result = { value: NOTMYAPP, b1, value1, b2, value2, third, thirdValue };
            if (third) {
                result.b3 = third;
            }
            return result;
        }
        return null;
    }
    //选择模块
    currentModuleId = null;
    setModuleSelect = (module, isClick = false) => {
        let newAppInfo = null;
        // console.log(module)
        const moduleID = module.value;
        if (!moduleID) { return; }
        this.currentModuleId = moduleID;
        
        newAppInfo = this.getModuleInfo(moduleID, this.state.appGroupArr);
        this.updateModuleInfo(newAppInfo);
        this.setState({ isSelectModuleID: moduleID, navAppInfo: newAppInfo, isActive: true });
        this.getApps(module).then(data => {
            if (module.value !== this.currentModuleId) {
                // 由于是异步，接口返回时可能已经选择别的模块了
                // console.log('数据不属于当前选中模块', module, this.currentModuleId);
                return;
            }

            if (data.length > 0) {
                this.setState({ contentData: data });
            }
            //如果返回数组为空的页面也显示为空
            if (data.length == 0) {
                this.setState({ contentData: [] });
            }
            //如果是点击 不用出现动画
            if (!isClick) {
                this.setState({ showContent: true });
            }
        });
    };
    updateModuleInfo = (moduleInfo, upStore = true) => {
        upStore && setStore(MYAPPINFO, moduleInfo);
        this.props.onUserSelectModule(moduleInfo);
    }
    // 一级标题选中状态
    getFirstTitleFlag = (group, expanded) => {
        const { isActive, navAppInfo } = this.state;
        // console.log(navAppInfo)
        // console.log(MYAPP)
        let flag = false;
        const data = group && group.children || [];
        if ((!group && ((navAppInfo && navAppInfo.value === MYAPP) || !navAppInfo.b1))) {
            // 默认为 我的应用时也加上标识 
            flag = true;
            return flag;
        }
        if (navAppInfo && isActive && !expanded && navAppInfo.value !== MYAPP) {
            // 领域
            for (let i of data) {
                if (i.value == navAppInfo.value2) {
                    flag = true;
                    return flag;
                }
            }
            return;
        }
    }
    renderFieldTitle = (label, icon, group = '', expanded = false) => {
        const flag = this.getFirstTitleFlag(group, expanded);
        let appIcon = (<img src={icon ? icon : NavAppIcons.optimize['default']} />);
        return (
            <div className={`field-title`}>
                {/* <i className={`iconfont ${icon || 'icon-liebiao'}`}/> */}
                <div className={`line ${flag ? 'show-line' : ''}`}></div>
                {/* {flag && <div className='line'></div>} */}
                {appIcon}
                {label}
            </div>
        );
    }
    renderFieldAppList = (group, isCloudMenu) => {
        let { label: groupLabel, value: groupValue, children } = group;
        return (
            <div className="field-app-list">
                {children.length && children.map((child, i) => {
                    return <React.Fragment>
                        {this.renderMenuGroup(group, child, isCloudMenu)}
                        {!child.children && this.renderAppTitle({ n1: group, n2: child }, isCloudMenu)}
                    </React.Fragment>;
                })}
            </div>
        );
    }

    //渲染左树三级菜单
    renderMenuGroup = (group, menuList, isCloudMenu) => {
        if (!menuList.children) { return null; }
        return (
            <div className="app-menu">
                <div className="app-menu-title">{menuList.label}</div>
                <div className="app-menu-content">
                    {menuList.children.map(item =>
                        this.renderAppTitle({ n1: group, n2: menuList, n3: item }, isCloudMenu),
                    )}
                </div>
            </div>
        );
    }

    //渲染左树菜单标题 n1:第一级 n2:第二级 n3:第三级 
    renderAppTitle = ({ n1, n2, n3 }) => {
        const { isActive } = this.state;
        let { label, value } = n2;
        //有三级取三级菜单
        if (n3 !== undefined) {
            label = n3.label;
            value = n3.value;
        }
        const moduleActived = this.checkIsActiveItem({ n1, n2, n3 }) && isActive;
        return (
            <div className="app-col" key={[label, value].join('_')}>
                <div className="list-item">
                    <div
                        className={
                            moduleActived
                                ? 'list-item-content active'
                                : 'list-item-content'
                        }
                        onClick={() => {
                            const isClick = true;
                            this.setModuleSelect(n3 || n2, isClick);
                        }}
                    >
                        <div className="title">
                            <span>{label}</span>
                        </div>
                        {this.checkIsActiveItem({ n1, n2, n3 }) && isActive && <div className='line'></div>}
                    </div>
                </div>
            </div>
        );
    }
    // 我的应用点击
    onExpandedCollect = () => {
        const newAppInfo = {
            b1: langCheck("0000PUB-000552") /* 国际化处理： 我的应用*/,
            b2: '',
            b3: '' /* 国际化处理： 我的收藏*/,
            n: '',
            value: MYAPP,
        };
        this.updateModuleInfo(newAppInfo);
        this.setState({ navAppInfo: newAppInfo });
        this.getMyappData();
    }
    onFieldCardExpanded = index => {
        return expanded => {
            let { collapsedFields } = this.state;
            collapsedFields[index].expanded = expanded;
            setStore('COLLAPSEDFIELDS', collapsedFields);
            this.setState({ collapsedFields });
        };
    }
    // 我的应用
    myAppGroup = () => {
        const { isActive, myAppData } = this.state;
        const { image_src, label, value } = myAppData;
        return (
            <Element
                className="result-group-list"
                key={[label, value].join('_')}
                name={`nav_${value}`}
            >
                <CardItem
                    className="field-card"
                    title={this.renderFieldTitle(label, image_src)}
                    focused={isActive}
                    expanded={false}
                    isMyApp={true}
                    onExpanded={this.onExpandedCollect}
                >
                </CardItem>
            </Element>
        );
    }
    //渲染菜单
    siderGroup = () => {
        let { collapsedFields, appGroupArr, cloudMenuData } = this.state;
        let firstLevelModule = this.findFirstLevelModule();
        const isCloudMenu = false; //本来用来判断是否bip菜单的，但是改了render就没用了，先留着，万一以后有用
        // const isCloudMenu = type === 'cloud'; //bip云菜单
        // let dataSource = isCloudMenu ? cloudMenuData : appGroupArr;
        return appGroupArr.map((group, index) => {
            let { value, label, image_src } = group;
            let expanded = true;
            if (collapsedFields[index]) {
                expanded = collapsedFields[index].expanded === undefined
                    ? true
                    : collapsedFields[index].expanded;
            }
            return (
                <Element
                    className="result-group-list"
                    key={[label, value].join('_')}
                    name={`nav_${group.value}`}
                >
                    <CardItem
                        className="field-card"
                        title={this.renderFieldTitle(label, image_src, group, expanded)}
                        index={index}
                        onExpanded={this.onFieldCardExpanded(index)}
                        isMyApp={false}
                        expanded={expanded}
                        focused={firstLevelModule && firstLevelModule.value === value}
                    >
                        {this.renderFieldAppList(group, isCloudMenu)}
                    </CardItem>
                </Element>
            );
        });
    }
    // 我的收藏接口
    queryappcollect = () => {
        return new Promise(resolve => {
            Ajax({
                url: API_URL.queryAppCollects,
                success: res => {
                    let { data, success } = res.data;
                    if (success) {
                        const { authorChange, result } = data;
                        if (authorChange) {
                            ControlTip(
                                {
                                    status: "warning",
                                    title: langCheck("0000PUB-000460"), /* 国际化处理： 权限变动*/
                                    msg: langCheck('0000PUB-000459'), // 多语 - 由于应用权限变动，您的收藏应用被取消，如有需要请您联系管理员配置,
                                    isCancelBtn: false,
                                    fieldid: 'collectAuthorChange',
                                },
                            );
                        }
                        const newResult = _.cloneDeep(result).map(item => {
                            item.is_collect = true;
                            return item;
                        });
                        const contentData = [
                            {
                                image_src: MyCollect,
                                label: langCheck('0000PUB-000404'), //多语 - 我的收藏
                                value: MYCOLLECT,
                                children: newResult,
                            },
                        ];
                        resolve(contentData);
                    }
                },
            });
        });

    }
    // 最近访问接口
    getRecentData = () => {
        return new Promise(resolve => {
            queryRecentVisit().then(result => {
                const contentData = [
                    {
                        image_src: RecentVisitImg,
                        label: langCheck('0000PUB-000276'), //多语 - 最近访问
                        value: RECENTVISIT,
                        children: result,
                    },
                ];
                resolve(contentData);
            });
        });
    };
    /**
     * 查询App接口
     * @param {Object} module
     */
    getApps = (module = {}) => {
        // moduleId === undefined 查询一二级领域模块，有值的情况查询模块下应用
        const { value: moduleId, is_cloud_app } = module;
        let info = {
            name: langCheck('0000PUB-000101'), /* 国际化处理： 所有应用*/
            appcode: '10228888',
            action: moduleId === undefined
                ? langCheck('0000PUB-000102') /* 国际化处理： 查询一二级领域模块*/
                : langCheck('0000PUB-000103'), /* 国际化处理： 查询模块下应用*/
        };
        let reqData = { apptype: '1', own_module: moduleId };
        if (moduleId !== undefined) {
            reqData.is_cloud_app = is_cloud_app;
        }

        const cacheKey = moduleId === undefined ? 'appModuleMenus' : `moduleMenus${moduleId}`;
        let appModuleMenus = getStore(cacheKey);
        if (appModuleMenus) {
            return new Promise(resolve => {
                resolve(appModuleMenus);
            });
        }
        const menusPromise = getMenus({
            info,
            data: reqData
        });
        menusPromise.then(data => {
            setStore(cacheKey, data);
        })
        return menusPromise;
    }
    /**
     *  我的应用数据
     */
    getMyappData = async () => {
        const collectData = await this.queryappcollect();
        const recentData = await this.getRecentData();
        const contentData = [...collectData, ...recentData];
        this.setState({
            contentData,
            isActive: false,
            showContent: true,
        });
    }

    findFirstLevelModule = () => {
        let { appGroupArr, navAppInfo } = this.state;
        if (!navAppInfo) { return {}; }
        let level1 = _.find(appGroupArr, item => item.label === navAppInfo.b1);
        return level1;
    }

    findAppItemModuleId = () => {
        // let { navAppInfo } = this.props;
        let { appGroupArr, navAppInfo } = this.state;
        if (!navAppInfo) { return undefined; }
        let level1 = _.find(appGroupArr, item => item.label === navAppInfo.b1);
        let result = null;
        if (level1) {
            result = _.find(level1.children, item => item.label === navAppInfo.b2);
        }
        //左侧有三级菜单
        if (result && (navAppInfo.b4 || navAppInfo.third) && result.children) {
            result = result.children.find(item => item.label === navAppInfo.b3);
        }
        return result || {};
    }
    /**
     * 检测节点是否为激活状态
     * n1, n2, n3 对应一到三级
     */
    checkIsActiveItem = ({ n1, n2, n3 }) => {
        let ret = false;
        let { isSelectModuleID } = this.state;
        let { navAppInfo } = this.props;
        if (navAppInfo) {
            const { b1, value1, b2, value2, third, thirdValue } = navAppInfo;
            //判断是否有三级菜单
            if (n3) {
                if (third) {
                    if (value1 === n1.value && value2 === n2.value && thirdValue === n3.value) {
                        ret = true;
                    }
                } else if (navAppInfo.b4) {
                    //点击菜单其他节点再点面包屑的场景
                    if (value1 === n1.value && value2 === n2.value && navAppInfo.b3 === n3.label) {
                        ret = true;
                    }
                }
            } else if (value1 === n1.value && value2 === n2.value) {
                ret = true;
            }

        } else if (isSelectModuleID === n2.value) {
            ret = true;
        }
        return ret;
    }
    // 一键清空选中状态
    clearContentData = contentData => {
        this.setState({ contentData });
    }
    // 修改收藏状态
    setNewContentData = contentData => {
        this.setState({ contentData });
    }

    /**
     * 原来人力领域在NCC有一部分菜单，现在与BIP的菜单融合，需要将BIP的人力与NCC的人力菜单合到一起
     * @param {*} menuData ncc的菜单数据
     * @returns 
     */
    mergeHRModules = (menuData = this.state.appGroupArr) => {
        let appGroupArr = _.cloneDeep(menuData);
        if (this.HRModules && this.HRModules.children && this.HRModules.children.length) {
            appGroupArr = appGroupArr.map(item => {
                //合并人力资本领域
                if (item.value === HR_FIELD_CODE) {
                    item.children = [...item.children, ...this.HRModules.children];
                }
                return item;
            });
        }
        return appGroupArr;
    }

    render() {
        const { contentData, showContent } = this.state;
        const { navAppInfo, showAllApp } = this.props;
        return (
            <Fragment>
                <TransitionIn in={showContent}>
                    <div className="all-apps-layout" fieldid="microapp-content-actived">
                        <Element
                            className="sider domain-group-container"
                            fieldid="nav-group"
                            id="domain-group-container"
                        >
                            {this.myAppGroup()}
                            {this.siderGroup()}
                            {/* 本来bip菜单是单独render的，但是后来改成bip菜单数据合并到appGroupArr后就没用了，先留着，万一以后有用 by liyaoh */}
                            {/* {this.siderGroup('cloud')} */}
                        </Element>
                        {
                            contentData && (
                                <MyContent
                                    contentData={contentData}
                                    handleUpdate={this.handleUpdate}
                                    navAppInfo={navAppInfo}
                                    clearContentData={this.clearContentData}
                                    setNewContentData={this.setNewContentData}
                                    moduleId={this.findAppItemModuleId()}
                                    getMyappData={this.getMyappData}
                                    updateModuleInfo={this.updateModuleInfo}
                                    showAllApp={showAllApp}
                                />
                            )
                        }
                    </div>
                </TransitionIn>
                {!showContent && <div className='allapps-loading'><Loading /></div>}
            </Fragment>
        );
    }
}
// export default withRouter(
//     connect(
//         state => ({ breadCrumbClick: state.appData.breadCrumbClick }),
//     )(AllApps),
// );
export default connect(
    state => ({ breadCrumbClick: state.appData.breadCrumbClick }),
)(AllApps);
